"use client"

import { Button } from "@/components/ui/button"
import { ArrowRight, Sparkles } from "lucide-react"
import { useLanguage } from "@/lib/i18n/language-context"

export function HeroSection() {
  const { t } = useLanguage()

  return (
    <section className="relative overflow-hidden px-4 py-20 md:px-6 md:py-32 lg:py-40">
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-0 h-[600px] w-[600px] -translate-x-1/2 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[400px] w-[400px] rounded-full bg-accent/10 blur-3xl" />
      </div>

      <div className="container mx-auto max-w-5xl text-center">
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-muted/50 px-4 py-1.5 text-sm backdrop-blur">
          <Sparkles className="h-4 w-4 text-primary" />
          <span className="text-muted-foreground">{t.newGenPlatform}</span>
        </div>

        <h1 className="mb-6 text-balance text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
          {t.heroTitle}
        </h1>

        <p className="mx-auto mb-8 max-w-2xl text-pretty text-lg text-muted-foreground md:text-xl">
          {t.heroDescription}
        </p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button size="lg" className="min-w-[200px] gap-2">
            {t.startNow}
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button size="lg" variant="outline" className="min-w-[200px] bg-transparent">
            {t.viewDemo}
          </Button>
        </div>

        <div className="mt-12 text-sm text-muted-foreground">{t.trustedBy}</div>
      </div>
    </section>
  )
}
